import { type StackNavigationOptions } from '@react-navigation/stack';
import React, { useCallback } from 'react';
import { Background, ArrowLeft, AuthButton, Logo } from '~/components/Header';
import { Home, IframeScreen, AboutMarisaCard } from '~/scenes';
import { WebHeader } from '~/components';
import { isWeb } from '~/utils/device';
import {
  AuthNavigation,
  CheckoutNavigation,
  ContractSellerNavigation,
  HiredInsuranceNavigation,
  BagProtectionNavigation,
  // IncomeProtectionNavigation,
  InsuranceAutoNavigation,
  TakesCareNavigation,
  CredsystemNavigation,
  UnemploymentAssistanceNavigation,
  OdontoProtectionNavigation,
  PersonalLoanNavigation,
} from './groups';
import { Stack } from './stackNavigation';

const defaultScreenOptions: StackNavigationOptions = {
  headerBackground: () => <Background />,
  headerLeft: () => <ArrowLeft />,
  headerRight: () => <AuthButton />,
  headerShadowVisible: false,
  headerTitle: () => <Logo />,
  headerTitleAlign: 'center',
  title: 'Marisa Serviços',
  header: isWeb ? () => <WebHeader /> : undefined,
};

export default function RootNavigation() {
  const HomeLogo = useCallback(() => <Logo canGoBack={false} />, []);

  return (
    <Stack.Navigator
      screenOptions={defaultScreenOptions}
      initialRouteName="MarisaServicos_Home"
    >
      <Stack.Screen
        name="MarisaServicos_Home"
        component={Home}
        options={{
          headerTitle: HomeLogo,
        }}
      />

      <Stack.Screen name="MarisaServicos_Iframe" component={IframeScreen} />

      <Stack.Screen
        name="MarisaServicos_AboutMarisaCard"
        component={AboutMarisaCard}
      />

      {AuthNavigation}

      {TakesCareNavigation}

      {BagProtectionNavigation}

      {/* {IncomeProtectionNavigation} */}

      {UnemploymentAssistanceNavigation}

      {OdontoProtectionNavigation}

      {PersonalLoanNavigation}

      {InsuranceAutoNavigation}

      {ContractSellerNavigation}

      {HiredInsuranceNavigation}

      {CheckoutNavigation}

      {CredsystemNavigation}
    </Stack.Navigator>
  );
}
